import * as React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import { Tag } from '@sales-center/components'
import { useData } from './hooks'
import type { Activity } from '../../../../typings'
import { useTheme } from '@mui/material/styles'

type Props = {
  activity: Activity
}

export function ActivitiesListItemInfo(props: Props) {
  const {
    activityInfo,
    dateColor,
    color,
    showDate,
    isCompleted,
    tagTextColor,
  } = useData(props)
  const theme = useTheme()
  return (
    <Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <AssignmentOutlined color="primary" fontSize="small" />
        <Typography
          variant="subtitle1"
          color={theme.palette.text.primary}
          maxWidth={252}
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
        >
          Subject: {activityInfo.subject}
        </Typography>
      </Stack>
      {showDate && (
        <Typography
          variant="body2"
          lineHeight={1.3}
          color={dateColor}
          textAlign="initial"
        >
          <Typography fontFamily="Source Sans Pro Semibold" component="span">
            {isCompleted ? 'Date Completed:' : 'Due Date:'}
          </Typography>{' '}
          {activityInfo.date}
        </Typography>
      )}
      <Box mt={0.4} color={tagTextColor}>
        <Tag title={activityInfo.status} color={color} />
      </Box>
    </Stack>
  )
}
